import React from 'react';
import HeaderNavigation from 'components/layout/header/HeaderNavigation';
import TeamsHeaderSection from 'components/layout/team/TeamsHeaderSection';
import TheTeamSection from 'components/layout/team/TheTeamSection';
import TeamsValuesSection from 'components/layout/team/TeamsValuesSection';
import FooterMain from 'components/layout/footer/FooterMain';
import styles from 'styles/pages/TeamsPage.module.sass';

/**
 * TeamsPage
 * 
 * This is the main page for showcasing the Zerone Analytics team.
 * 
 * Structure and Purpose:
 * - Displays the company navigation bar at the top.
 * - Shows an introductory section (TeamsHeaderSection) with a brief about the team and a call-to-action to join.
 * - Renders TheTeamSection, which presents a grid of team members with their photos, names, and roles.
 * - Includes TeamsValuesSection, highlighting the core values and culture that drive the company.
 * - Ends with the main site footer.
 * 
 
 */

const TeamsPage: React.FC = () => (
  <>
    <HeaderNavigation theme="dark" />
    <div className={styles['teams-page']}>
      <TeamsHeaderSection />
      <TheTeamSection />
      <TeamsValuesSection />
    </div>
    <FooterMain /> 
  </>
);

export default TeamsPage;
